import { schoolYearsData } from './schoolYearsData.js';
import { appointedYears } from './appointedYearsData.js';
import { equateYears } from './equateYearsData.js';

export const schoolPsychologistData = [
    {
        id: 'hello-there',
        jobTitle: 'school-psychologist',
        components: [
            {
                type: "Title",
                content: "School Psychologist",
            },
            {
                type: "Sub Title",
                content: "There are <strong>three factors</strong> that influence your pay:"
            },
            {
                type: "Content Box",
                title: "College Credits",
                textAlign: "left",
                icon: "college-credits",
                content: [
                    {
                        content: '"Differentials"',
                    },
                ]
            },
            {
                type: "Content Box",
                title: "Working Experience",
                textAlign: "left",
                icon: "teach-exp",
                content: [
                    {
                        content: '"Salary Steps"',
                    },
                ]
            },
            {
                type: "Content Box",
                title: "Length of Employment",
                textAlign: "left",
                icon: "employment-length",
                content: [
                    {
                        content: '"Longevity"',
                    },
                ]
            },
            {
                type: "Content",
                content: "We're going to check each one for errors."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Get started", 
                        linkId: "appointed-under-a-different-title",
                    }
                ]
            }
        ]
    },
    {
        id: 'appointed-under-a-different-title',
        jobTitle: 'school-psychologist',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Title",
                content: "Before we begin...",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Have you ever been appointed under a different title by the NYC DOE?",
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "to-which-title-were-you-appointed",
                    },
                    {   
                        question: "No",
                        answerId: "college-credits"
                    }
                ]
            }
        ]
    },
    {
        id: 'to-which-title-were-you-appointed',
        jobTitle: 'school-psychologist',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Sub Title",
                content: "To which title were you appointed?",
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Paraprofessional",
                        answerId: "got-it"
                    },
                    {   
                        question: "Something Else",
                        answerId: "call-a-uft-salary-specialist"
                    }
                ]
            }
        ]
    },
    {
        id: 'got-it',
        jobTitle: 'school-psychologist',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Title",
                content: "Got it!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "Your experience as a paraprofessional does not impact your current role. You may continue checking your salary.",
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "college-credits",
                    }
                ]
            }
        ]
    },
    {
        id: "call-a-uft-salary-specialist",
        jobTitle: 'school-psychologist',
        background: [
            {
                color: "#F4F9E8",
            }
        ],
        components: [
            {
                type: "Title",
                content: "This tool may not work for you.",
                underline: true
            },
            {
                type: "Content",
                content: "Please call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a> if you would like to check your salary for errors."
            }
        ]
    },
    {
        id: 'college-credits',
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/college-credits-dark-green.png"),
                alt: "Graudation Cap Icon",
                width: "98px"
            },
            {
                type: "Title",
                content: "College Credits"
            },
            {
                type: "Content",
                content: "If you have a master's degree or a doctorate from a regionally accredited college/university, you may be able to increase your pay with a salary differential. Let's see if you qualify. "
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Check your credits",
                        linkId: "do-you-have-your-phd-in-social-work-or-psychology",
                    }
                ]
            }
        ]
    },
    {
        id: 'do-you-have-your-phd-in-social-work-or-psychology',
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Do you have your doctorate in either Social Work or Psychology?"
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "wm"
                    },
                    {   
                        question: "No",
                        answerId: "do-you-have-a-masters-degree"
                    }
                ]
            }
        ]
    },
    {
        id: 'do-you-have-a-masters-degree',
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Do you have your master’s degree?"
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "is-your-masters-degree-in-social-work-or-psychology"
                    },
                    {   
                        question: "No",
                        answerId: "wk"
                    }
                ]
            }
        ]
    },
    {
        id: 'is-your-masters-degree-in-social-work-or-psychology',
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Is your master’s degree in either Social Work or Psychology?"
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "was-your-masters-degree-program-60-or-more-credits"
                    },
                    {   
                        question: "No",
                        answerId: "since-earning-your-masters-degree-have-you-earned-30-or-more-credits-that-werent-part-of-your-bachelors-degree"
                    }
                ]
            }
        ]
    },
    {
        id: 'was-your-masters-degree-program-60-or-more-credits',
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Was your master’s degree program 60 or more credits?"
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "wl"
                    },
                    {   
                        question: "No",
                        answerId: "do-you-have-60-or-more-additional-credits-in-graduate-study-in-social-work-or-psychology"
                    }
                ]
            }
        ]
    },
    {
        id: 'do-you-have-60-or-more-additional-credits-in-graduate-study-in-social-work-or-psychology',
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Do you have 60 or more additional credits in Graduate Study in either Social Work or Psychology?"
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "wl"
                    },
                    {   
                        question: "No",
                        answerId: "since-earning-your-masters-degree-have-you-earned-30-or-more-credits-that-werent-part-of-your-bachelors-degree"
                    }
                ]
            }
        ]
    },
    {
        id: 'since-earning-your-masters-degree-have-you-earned-30-or-more-credits-that-werent-part-of-your-bachelors-degree',
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Since earning your master’s degree, have you earned 30 or more credits that WERE NOT part of your bachelor’s degree?"
            },
            {
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "wl"
                    },
                    {   
                        question: "No",
                        answerId: "wk"
                    }
                ]
            }
        ]
    },
    {
        id: "wk",
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "You likely don’t qualify for a differential at this time.",
            },
            {
                type: "Content",
                content: "Check back after you have you earned 60 or more credits from an accredited institution."
            },
            {
                type: 'Differentials',
                content: [
                    {   
                        dollarSign: "$$$",
                        title: "WM",
                        content: "Vlf3+Vlk3",
                        qualify: false
                    },
                    {   
                        dollarSign: "$$",
                        title: "WL",
                        content: "Vlf2+Vlk2",
                        qualify: false
                    },
                    {   
                        dollarSign: "$",
                        title: "WK",
                        content: "Vlf+Vlk",
                        nickname: "Base Salary",
                    }
                ]
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "wk-pay-stub",
                    }
                ]
            }
        ]
    },
    {
        id: 'wl',
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type:"Title",
                content: "Way to go!"
            },
            {
                type: "Content",
                content: "You likely qualify for the first differential."
            },
            {
                type: 'Differentials',
                content: [
                    {   
                        dollarSign: "$$$",
                        title: "WM",
                        content: "Vlf3+Vlk3",
                        qualify: false
                    },
                    {   
                        dollarSign: "$$",
                        title: "WL",
                        content: "Vlf2+Vlk2"
                    },
                    {   
                        dollarSign: "$",
                        title: "WK",
                        content: "Vlf+Vlk",
                        nickname: "Base Salary",
                        qualify: false
                    }
                ]
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "wl-pay-stub",
                    }
                ]
            }
        ]
    },
    {
        id: 'wm',
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type:"Title",
                content: "Way to go!"
            },
            {
                type: "Content",
                content: "You likely qualify for the highest differential."
            },
            {
                type: 'Differentials',
                content: [
                    {   
                        dollarSign: "$$$",
                        title: "WM",
                        content: "Vlf3+Vlk3"
                    },
                    {   
                        dollarSign: "$$",
                        title: "WL",
                        content: "Vlf2+Vlk2",
                        qualify: false
                    },
                    {   
                        dollarSign: "$",
                        title: "WK",
                        content: "Vlf+Vlk",
                        nickname: "Base Salary",
                        qualify: false
                    }
                ]
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "wm-pay-stub",
                    }
                ]
            }
        ]
    },
    {
        id: "wk-pay-stub",
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Are these the first two letters of your salary code on the payroll portal?"
            },
            {
                type: "Pay Code Stub",
                paycode: "WK"
            },
            {
                type: 'Modal',
                label: 'Where do I find this?',
                title: "Where to find your salary code:",
                content: [
                    {
                        type: "Content",
                        content: "1. Log into the <a href='https://payrollportal.nycboe.net' class='text-link' target='_blank'>NYC DOE payroll portal</a>",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "2. Under Employee Self Service, select Payroll Register",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-1.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "3. Select the tab labeled Salary Info",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-2.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "4. Your differential is represented by the first two characters of your salary code",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-psychologist.png"),
                        width: "100%"
                    }
                ]
            },
            {   
                type: 'Question', 
                id: "step-1-status",
                content: [
                    {
                        question: "Yes",
                        value: "pass",
                        answerId: "correct-pay"
                    },
                    {   
                        question: "No",
                        answerId: "have-you-submitted-a-differential-application"
                    }
                ]
            }
        ]
    },
    {
        id: "wl-pay-stub",
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Are these the first two letters of your salary code on the payroll portal?"
            },
            {
                type: "Pay Code Stub",
                paycode: "WL"
            },
            {
                type: 'Modal',
                label: 'Where do I find this?',
                title: "Where to find your salary code:",
                content: [
                    {
                        type: "Content",
                        content: "1. Log into the <a href='https://payrollportal.nycboe.net' class='text-link' target='_blank'>NYC DOE payroll portal</a>",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "2. Under Employee Self Service, select Payroll Register",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-1.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "3. Select the tab labeled Salary Info",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-2.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "4. Your differential is represented by the first two characters of your salary code",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-psychologist.png"),
                        width: "100%"
                    }
                ]
            },
            {   
                type: 'Question', 
                id: "step-1-status",
                content: [
                    {
                        question: "Yes",
                        value: "pass",
                        answerId: "correct-pay"
                    },
                    {   
                        question: "No",
                        answerId: "have-you-submitted-a-differential-application"
                    }
                ]
            }
        ]
    },
    {
        id: "wm-pay-stub",
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Are these the first two letters of your salary code on the payroll portal?"
            },
            {
                type: "Pay Code Stub",
                paycode: "WM"
            },
            {
                type: 'Modal',
                label: 'Where do I find this?',
                title: "Where to find your salary code:",
                content: [
                    {
                        type: "Content",
                        content: "1. Log into the <a href='https://payrollportal.nycboe.net' class='text-link' target='_blank'>NYC DOE payroll portal</a>",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "2. Under Employee Self Service, select Payroll Register",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-1.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "3. Select the tab labeled Salary Info",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-2.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "4. Your differential is represented by the first two characters of your salary code",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-psychologist.png"),
                        width: "100%"
                    }
                ]
            },
            {   
                type: 'Question', 
                id: "step-1-status",
                content: [
                    {
                        question: "Yes",
                        value: "pass",
                        answerId: "correct-pay"
                    },
                    {   
                        question: "No",
                        answerId: "have-you-submitted-a-differential-application"
                    }
                ]
            }
        ]
    },
    {
        id: "salary-differential-error",
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "You may have a salary differential error."
            },
            {
                type: "Content",
                content: "After your salary checkup is complete, report the error through <a href='https://hub.uft.org/uftselfservice/s/salary-inquiry-form' target='_blank' class='text-link'>this online form</a> or call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a>. We will include this information again on the final review.",
                textAlign: "center"
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "teaching-experience",
                    }
                ]
            }
        ]
    },
    {
        id: "have-you-submitted-a-differential-application",
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Sub Title",
                content: "Have you submitted a differential application?"
            },
            {
                type: 'Modal',
                label: 'What is this?',
                title: "What is a differential application?",
                content: [
                    {
                        type: "Content",
                        content: "Pay increases for qualifying college credits are not automatically granted. You must apply for a differential by completing an online form on the NYC DOE payroll portal, ideally within six months of earning your credits.",
                        textAlign: "center",
                    }
                ]
            },
            {   
                type: 'Question',
                id: "step-1-status",
                content: [
                    {
                        question: "Yes",
                        value: "fail",
                        answerId: "salary-differential-error",
                    },
                    {   
                        question: "No",
                        answerId: "you-should-submit-a-differential-application",
                    }
                ]
            }
        ]
    },
    {
        id: "you-should-submit-a-differential-application",
        jobTitle: 'school-psychologist',
        stepNumber: 1,
        components: [
            {
                type: "Alert",
                level: "warning",
                content: "Action Needed"
            },
            {
                type: "Sub Title",
                content: "You should submit a differential application to the NYC DOE."
            },
            {
                type: "Content",
                content: "We recommend doing this right now to ensure you get credit for your qualifying college credits."
            },
            {
                type: "External Text Link",
                label: "Submit a Differential Application",
                buttonStyle: true,
                link: "https://nycenet.edu/salapps"
            },
            {   
                type: 'Button',
                id: "step-1-status",
                content: [
                    {
                        label: "Continue with Salary Checkup",
                        linkStyle: true,
                        value: "fail",
                        linkId: "salary-differential-error"
                    }
                ]
            }
        ]
    },
    {
        id: "correct-pay",
        jobTitle: 'school-psychologist',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 1,
        components: [
            {
                type: "Title",
                content: "Great!",
                underline: true
            },
            {
                type: "Sub Title",
                content: "It sounds like you’re getting paid correctly for your college credits."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "teaching-experience",
                    }
                ]
            }
        ]
    },
    {
        id: "teaching-experience",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/teaching-exp-green.png"),
                width: "64px"
            },
            {
                type: "Title",
                content: "Working Experience"
            },
            {
                type: "Content",
                content: "School Psychologists earn salary increases for each year of satisfactory service they complete, up to a maximum of 7 years (not including longevity increases). The NYC DOE tracks your progress with salary steps, and sometimes errors occur. Let’s make sure you’re getting credit for all your hard work."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Watch your step",
                        linkId: "when-were-you-appointed-by-the-doe-in-your-current-title",
                    }
                ]
            }
        ]
    },
    {
        id: "when-were-you-appointed-by-the-doe-in-your-current-title",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed as a School Psychologist by the NYC DOE?"
            },
            ...schoolYearsData,
            {
                type: "Checkbox",
                id: "appointed-after-school-year",
                content:[
                    {
                        label: "I was appointed <em>after</em> the school year began",
                        value: "checked",
                    }
                ]
            },
            {   
                type: 'Button', 
                precedence: "checkbox", 
                content: [
                    {
                        label: "Continue",
                        linkId: [
                            "maxed-payroll-portal",
                            "do-you-know-your-equate-date",
                        ],
                        hidden: true,
                        variableId: "appointed-date"
                    },
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed",
                        hidden: true,
                        variableId: "appointed-after-school-year"
                    }
                ]
            },
        ]
    },
    {
        id: "when-were-you-appointed",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed?"
            },
            {
                type: "Dropdown",
                id: "appointed-month",
                content: [
                    {
                        label: "Month",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "January",
                        value: "01"
                    },
                    {
                        label: "February",
                        value: "02"
                    },
                    {
                        label: "March",
                        value: "03"
                    },
                    {
                        label: "April",
                        value: "04"
                    },
                    {
                        label: "May",
                        value: "05"
                    },
                    {
                        label: "June",
                        value: "06"
                    },
                    {
                        label: "July",
                        value: "07"
                    },
                    {
                        label: "August",
                        value: "08"
                    },
                    {
                        label: "September",
                        value: "09"
                    },
                    {
                        label: "October",
                        value: "10"
                    },
                    {
                        label: "November",
                        value: "11"
                    },
                    {
                        label: "December",
                        value: "12"
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "appointed-day",
                content: [
                    {
                        label: "Day",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1",
                        value: "1"
                    },
                    {
                        label: "2",
                        value: "2"
                    },
                    {
                        label: "3",
                        value: "3"
                    },
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "5",
                        value: "5"
                    },
                    {
                        label: "6",
                        value: "6"
                    },
                    {
                        label: "7",
                        value: "7"
                    },
                    {
                        label: "8",
                        value: "8"
                    },
                    {
                        label: "9",
                        value: "9"
                    },
                    {
                        label: "10",
                        value: "10"
                    },
                    {
                        label: "11",
                        value: "11"
                    },
                    {
                        label: "12",
                        value: "12"
                    },
                    {
                        label: "13",
                        value: "13"
                    },
                    {
                        label: "14",
                        value: "14"
                    },
                    {
                        label: "15",
                        value: "15"
                    },
                    {
                        label: "16",
                        value: "16"
                    },
                    {
                        label: "17",
                        value: "17"
                    },
                    {
                        label: "18",
                        value: "18"
                    },
                    {
                        label: "19",
                        value: "19"
                    },
                    {
                        label: "20",
                        value: "20"
                    },
                    {
                        label: "21",
                        value: "21"
                    },
                    {
                        label: "22",
                        value: "22"
                    },
                    {
                        label: "23",
                        value: "23"
                    },
                    {
                        label: "24",
                        value: "24"
                    },
                    {
                        label: "25",
                        value: "25"
                    },
                    {
                        label: "26",
                        value: "26"
                    },
                    {
                        label: "27",
                        value: "27"
                    },
                    {
                        label: "28",
                        value: "28"
                    },
                    {
                        label: "29",
                        value: "29"
                    },
                    {
                        label: "30",
                        value: "30"
                    },
                    {
                        label: "31",
                        value: "31"
                    },
                ]
            },
            ...appointedYears,
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: [
                            "maxed-payroll-portal",
                            "do-you-know-your-equate-date",
                        ],
                        hidden: true,
                        variableId: [
                            "appointed-month",
                            "appointed-day",
                            "appointed-year"
                        ]
                    }
                ]
            },
        ]
    },
    {
        id: "do-you-know-your-equate-date",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Do you know your equate date?"
            },
            {
                type: 'Modal',
                label: 'What is an equate date?',
                title: "What is an equate date?",
                content: [
                    {
                        type: "Content",
                        content: "Your equate date is used by the NYC DOE to calculate which salary step you are on. The NYC DOE takes your appointed date and then factors in any qualifying prior experience. So, if you have qualifying prior experience, your equate date should be earlier than your hire date.",
                        textAlign: "left",
                    }
                ]
            },
            {
                type: 'Modal',
                label: 'Where can I find my equate date?',
                title: "Where to find your equate date:",
                content: [
                    {
                        type: "Content",
                        content: "1. Log into the <a href='https://payrollportal.nycboe.net'  class='text-link' target='_blank'>NYC DOE payroll portal</a>",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "2. Under Employee Self Service, select Payroll Register",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-1.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "3. Select the tab labeled Salary Info",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-2.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "4. This will display your equate date",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-4.jpg"),
                        width: "100%"
                    }
                ]
            },
            {   
                type: 'Question', 
                content: [
                    {
                        question: "Yes",
                        answerId: "what-is-your-equate-date",
                    },
                    {   
                        question: "No",
                        answerId: "did-you-receive-salary-step-credit",
                    }
                ]
            }
        ]
    },
    {
        id: "what-is-your-equate-date",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "What is your equate date?"
            },
            {
                type: "Dropdown",
                id: "equate-month",
                content: [
                    {
                        label: "Month",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "January",
                        value: "01"
                    },
                    {
                        label: "February",
                        value: "02"
                    },
                    {
                        label: "March",
                        value: "03"
                    },
                    {
                        label: "April",
                        value: "04"
                    },
                    {
                        label: "May",
                        value: "05"
                    },
                    {
                        label: "June",
                        value: "06"
                    },
                    {
                        label: "July",
                        value: "07"
                    },
                    {
                        label: "August",
                        value: "08"
                    },
                    {
                        label: "September",
                        value: "09"
                    },
                    {
                        label: "October",
                        value: "10"
                    },
                    {
                        label: "November",
                        value: "11"
                    },
                    {
                        label: "December",
                        value: "12"
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "equate-day",
                content: [
                    {
                        label: "Day",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1",
                        value: "1"
                    },
                    {
                        label: "2",
                        value: "2"
                    },
                    {
                        label: "3",
                        value: "3"
                    },
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "5",
                        value: "5"
                    },
                    {
                        label: "6",
                        value: "6"
                    },
                    {
                        label: "7",
                        value: "7"
                    },
                    {
                        label: "8",
                        value: "8"
                    },
                    {
                        label: "9",
                        value: "9"
                    },
                    {
                        label: "10",
                        value: "10"
                    },
                    {
                        label: "11",
                        value: "11"
                    },
                    {
                        label: "12",
                        value: "12"
                    },
                    {
                        label: "13",
                        value: "13"
                    },
                    {
                        label: "14",
                        value: "14"
                    },
                    {
                        label: "15",
                        value: "15"
                    },
                    {
                        label: "16",
                        value: "16"
                    },
                    {
                        label: "17",
                        value: "17"
                    },
                    {
                        label: "18",
                        value: "18"
                    },
                    {
                        label: "19",
                        value: "19"
                    },
                    {
                        label: "20",
                        value: "20"
                    },
                    {
                        label: "21",
                        value: "21"
                    },
                    {
                        label: "22",
                        value: "22"
                    },
                    {
                        label: "23",
                        value: "23"
                    },
                    {
                        label: "24",
                        value: "24"
                    },
                    {
                        label: "25",
                        value: "25"
                    },
                    {
                        label: "26",
                        value: "26"
                    },
                    {
                        label: "27",
                        value: "27"
                    },
                    {
                        label: "28",
                        value: "28"
                    },
                    {
                        label: "29",
                        value: "29"
                    },
                    {
                        label: "30",
                        value: "30"
                    },
                    {
                        label: "31",
                        value: "31"
                    },
                ]
            },
            ...equateYears,
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: [
                            "maxed-payroll-portal",
                            "payroll-portal",
                            "equaate-date-error"
                        ],
                        hidden: true,
                        variableId: [
                            "equate-month",
                            "equate-day",
                            "equate-year"
                        ]
                    }
                ]
            },
        ]
    },
    {
        id: "equaate-date-error",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "Whoops!"
            },
            {
                type: "Sub Title",
                content: "Your equate date cannot be more recent than your appointed date."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Try Again",
                        linkId: "what-is-your-equate-date"
                    },
                    {
                        label: "I Don't Know My Equate Date",
                        linkStyle: true,
                        linkId: "did-you-receive-salary-step-credit"
                    }
                ]
            }
        ]
    },
    {
        id: "did-you-receive-salary-step-credit",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Did you receive salary step credit for past work experience within or outside the DOE?"
            },
            {
                type: 'Modal',
                label: 'What is this?',
                title: "What is salary step credit?",
                content: [
                    {
                        type: "Content",
                        content: "If you have qualifying past working experience (e.g., with a district outside of NYC, a private or parochial school, etc.) the NYC DOE may start you on a higher salary step (up to step 6A). To have your past experience considered for salary step credit, you should submit an Application for Salary Step Placement within 6 months of your appointment date. (If you submit your application late, you will not be eligible for retroactive pay.)",
                        textAlign: "left",
                    },
                ]
            },
            {   
                type: 'Question', 
                content: [
                    {
                        question: "Yes",
                        answerId: "how-much-salary-step-credit",
                    },
                    {   
                        question: "No",
                        answerId: "payroll-portal",
                    }
                ]
            }
        ]
    },
    {
        id: "how-much-salary-step-credit",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "How much salary step credit did you receive?"
            },
            {
                type: 'Modal',
                label: "What if I don't know?",
                title: "What if I don’t know how much salary credit I recieved?",
                content: [
                    {
                        type: "Content",
                        content: "If you don't know how much salary step credit you received from the NYC DOE, we cannot check if you are on the correct salary step. Please call a UFT Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a>.",
                        textAlign: "center",
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "term-length",
                content: [
                    {
                        label: "Terms",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1 Term (half a year)",
                        value: "1"
                    },
                    {
                        label: "2 Terms (1 year)",
                        value: "2"
                    },
                    {
                        label: "3 Terms (1.5 years)",
                        value: "3"
                    },
                    {
                        label: "4 Terms (2 years)",
                        value: "4"
                    },
                    {
                        label: "5 Terms (2.5 years)",
                        value: "5"
                    },
                    {
                        label: "6 Terms (3 years)",
                        value: "6"
                    },
                    {
                        label: "7 Terms (3.5 years)",
                        value: "7"
                    },
                    {
                        label: "8 Terms (4 years)",
                        value: "8"
                    },
                    {
                        label: "9 Terms (4.5 years)",
                        value: "9"
                    },
                    {
                        label: "10 Terms (5 years)",
                        value: "10"
                    },
                    {
                        label: "11 Terms (5.5 years)",
                        value: "11"
                    },
                    {
                        label: "12 Terms (6 years)",
                        value: "12"
                    }
                ]
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: [
                            "maxed-payroll-portal",
                            "payroll-portal"
                        ],
                        hidden: true,
                        variableId: "term-length"
                    }
                ]
            }
        ]
    },
    {
        id: "payroll-portal",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "In the NYC DOE payroll portal, are these the third and fourth characters of your salary code?"
            },
            {
                type: 'Modal',
                label: 'Where do I find this?',
                title: "Where to find your salary code:",
                content: [
                    {
                        type: "Content",
                        content: "1. Log into the <a href='https://payrollportal.nycboe.net' class='text-link' target='_blank'>NYC DOE payroll portal</a>",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "2. Under Employee Self Service, select Payroll Register",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-1.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "3. Select the tab labeled Salary Info",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-2.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "4. Your salary step is represented by the third and fourth characters of your salary code",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-psychologist.png"),
                        width: "100%"
                    }
                ]
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {
                type: "Equate Date",
                content: "We estimate your equate date is:"
            },
            {   
                type: 'Question', 
                content: [
                    {
                        question: "Yes",
                        answerId: "estimated-salary-step-schedule",
                    },
                    {   
                        question: "No",
                        answerId: "have-you-been-off-doe-payroll-for-more-than-30-days",
                    }
                ]
            }
        ]
    },
    {
        id: "maxed-payroll-portal",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Does this code appear in the NYC DOE payroll portal?"
            },
            {
                type: 'Modal',
                label: 'Where do I find this?',
                title: "Where to find your salary code:",
                content: [
                    {
                        type: "Content",
                        content: "1. Log into the <a href='https://payrollportal.nycboe.net' class='text-link' target='_blank'>NYC DOE payroll portal</a>",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "2. Under Employee Self Service, select Payroll Register",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-1.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "3. Select the tab labeled Salary Info",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-2.png"),
                        width: "100%"
                    },
                    {
                        type: "Content",
                        content: "4. Your salary step is represented by the third and fourth characters of your salary code",
                        textAlign: "left",
                    },
                    {
                        type: "Image",
                        image: require("../../src/imgs/payroll-portal-psychologist.png"),
                        width: "100%"
                    }
                ]
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {   
                type: 'Question', 
                content: [
                    {
                        question: "Yes",
                        answerId: "way-to-go",
                    },
                    {   
                        question: "No",
                        answerId: "have-you-been-off-doe-payroll-for-more-than-30-days",
                    }
                ]
            }
        ]
    },
    {
        id: "estimated-salary-step-schedule",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Here’s your forecasted salary step dates."
            },
            {
                type: "Modal",
                label: 'How accurate is this?',
                title: "How accurate is this?",
                content: [
                    {
                        type: "Content",
                        content: "This estimate of your salary step schedule assumes you will remain on NYC DOE payroll during this entire period and will have satisfactory evaluations each year.",
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "Events that can affect your salary step progress:",
                        listItems:[
                            "Unpaid leaves*",
                            "Overall unsatisfactory or ineffective rating"
                        ],
                        textAlign: "left",
                    },
                    {
                        type: "Content",
                        content: "*You must reapply for salary step credit when returning to NYC DOE payroll",
                        textAlign: "left",
                        textSize: "small"
                    }
                ]
            },
            {
                type: 'Salary Schedule'
            },
            {   
                type: 'Button',
                id: "step-2-status",
                content: [
                    {
                        label: "Continue",
                        value: "pass",
                        linkId: "great-teaching-experience"
                    }
                ]
            }
        ]
    },
    {
        id: "have-you-been-off-doe-payroll-for-more-than-30-days",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Have you ever been off NYC DOE payroll for more than 30 days?"
            },
            {   
                type: 'Question', 
                content: [
                    {
                        question: "Yes",
                        answerId: "did-you-resubmit-a-salary-step-placement-application",
                    },
                    {   
                        question: "No",
                        answerId: "have-you-ever-received-an-overall-rating-of-unsatisfactory",
                    }
                ]
            }
        ]
    },
    {
        id: "have-you-ever-received-an-overall-rating-of-unsatisfactory",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Have you ever received an overall rating of unsatisfactory or ineffective?"
            },
            {   
                type: 'Question', 
                id: "step-2-status",
                content: [
                    {
                        question: "Yes",
                        value: "fail",
                        answerId: "unpaid-leaves-and-unsatisfactory-evaluations",
                    },
                    {   
                        question: "No",
                        value: "fail",
                        answerId: "you-may-have-a-salary-step-error",
                    }
                ]
            }
        ]
    },
    {
        id: "did-you-resubmit-a-salary-step-placement-application",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Sub Title",
                content: "Did you resubmit a salary step placement application when you returned?"
            },
            {
                type: 'Modal',
                label: 'What is this?',
                title: "What is a salary step placement application?",
                content: [
                    {
                        type: "Content",
                        content: "If you are off payroll for more than 30 days, you must reestablish your equate date with the NYC DOE. You do this by completing an online form on the NYC DOE payroll portal.",
                        textAlign: "center",
                    }
                ]
            },
            {   
                type: 'Question',
                id: "step-2-status",
                content: [
                    {
                        question: "Yes",
                        value: "fail",
                        answerId: "you-may-have-a-salary-step-error",
                    },
                    {   
                        question: "No",
                        answerId: "you-should-resubmit-a-salary-step-placement-application",
                    }
                ]
            }
        ]
    },
    {
        id: "you-should-resubmit-a-salary-step-placement-application",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Alert",
                level: "warning",
                content: "Action Needed"
            },
            {
                type: "Sub Title",
                content: "You should resubmit a salary step placement application to the NYC DOE."
            },
            {
                type: "Content",
                content: "We recommend doing this right now to ensure you reestablish your equate date."
            },
            {
                type: "External Text Link",
                label: "Resubmit Your Application",
                buttonStyle: true,
                link: "https://nycenet.edu/salapps"
            },
            {   
                type: 'Button',
                id: "step-2-status",
                content: [
                    {
                        label: "Continue with Salary Checkup",
                        linkStyle: true,
                        value: "fail",
                        linkId: "salary-step-error"
                    }
                ]
            }
        ]
    },
    {
        id: "unpaid-leaves-and-unsatisfactory-evaluations",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "Unpaid leaves and unsatisfactory evaluations affect your progression through salary steps."
            },
            {
                type: "Content",
                content: "If you believe you have a salary step error, continue with your salary checkup, and then report the error through <a href='https://hub.uft.org/uftselfservice/s/salary-inquiry-form' target='_blank' class='text-link'>this online form</a> or call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a>. We will include this information again on the final review."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "you-may-have-a-salary-step-error",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "You may have a salary step error."
            },
            {
                type: "Content",
                content: "After your salary checkup is complete, report the error through <a href='https://hub.uft.org/uftselfservice/s/salary-inquiry-form' target='_blank' class='text-link'>this online form</a> or call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a>. We will include this information again on the final review.",
                textAlign: "center"
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "salary-step-error",
        jobTitle: 'school-psychologist',
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "You may have a salary step error."
            },
            {
                type: "Content",
                content: "After you resubmit a salary step placement application to the NYC DOE, this problem should be resolved. If you are still within 6 months of returning to work, you may also receive retroactive pay for the error."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "way-to-go",
        jobTitle: 'school-psychologist',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "Way to Go!",
                underline: true
            },
            {
                type: "Title",
                content: "You've reached the highest salary step."
            },
            {
                type: "Sub Title",
                content: "It sounds like you are getting paid correctly for your working experience."
            },
            {   
                type: 'Button',
                id: "step-2-status",
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment",
                        value: "pass"
                    }
                ]
            }
        ]
    },
    {
        id: "great-teaching-experience",
        jobTitle: 'school-psychologist',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 2,
        components: [
            {
                type: "Title",
                content: "Great!",
                underline: true
            },
            {
                type: "Sub Title",
                content: " It sounds like you are getting paid correctly for your working experience."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "length-of-employment"
                    }
                ]
            }
        ]
    },
    {
        id: "length-of-employment",
        jobTitle: 'school-psychologist',
        stepNumber: 3,
        components: [
            {
                type: "Image",
                content: require("../../src/imgs/length-of-employment-green.png"),
                alt: "Length of Emplpoyment Icon",
                width: "65px"
            },
            {
                type: "Title",
                content: "Length of Employment"
            },
            {
                type: "Content",
                content: "School Psychologists get additional salary increases on seven key milestones: 5, 10, 13, 15, 18, 20 and 22 years of service within NYC public schools. These increases, called longevities, add thousands to your salary—and your pension. Let’s see when you can celebrate."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Remember your anniversaries",
                        linkId: "correct-apponted-date"
                    }
                ]
            }
        ]
    },
    {
        id: "correct-apponted-date",
        jobTitle: 'school-psychologist',
        stepNumber: 3,
        components: [
            {
                type: "Appointed Date",
                content: "We estimate your appointed date is",
            },
            {
                type: "Sub Title",
                content: "Is this correct?"
            },
            {   
                type: 'Question',
                content: [
                    {
                        question: "Yes",
                        answerId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                    },
                    {   
                        question: "No",
                        answerId: "when-were-you-appointed-by-the-doe-in-your-current-title-incorrect",
                    }
                ]
            }
        ]
    },
    {
        id: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
        jobTitle: 'school-psychologist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Have you ever been off NYC DOE payroll for more than 30 days?"
            },
            {   
                type: 'Question',
                id: "step-3-status",
                content: [
                    {
                        question: "Yes",
                        value: "fail",
                        answerId: "off-doe-payroll-for-more-than-30-days"
                    },
                    {   
                        question: "No",
                        answerId: [
                            "no-longevity-increase",
                            "highest-longevity",
                            "longevity-increase"
                        ],
                        variableId: "appointed-date"
                    }
                ]
            }
        ]
    },
    {
        id: "off-doe-payroll-for-more-than-30-days",
        jobTitle: 'school-psychologist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Being off NYC DOE payroll for more than 30 days may impact your longevity schedule."
            },
            {
                type: "Content",
                content: "We recommend that you call a UFT Salary Specialist at <a href='tel:212-331-6311' class='text-link'>212-331-6311</a> to confirm your information."
            },
            {   
                type: 'Button',
                content: [
                    {
                        label: "Continue to Final Review",
                        linkStyle: true,
                        linkId: "final-review"
                    }
                ]
            }
        ]
    },
    {
        id: "when-were-you-appointed-by-the-doe-in-your-current-title-incorrect",
        jobTitle: 'school-psychologist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed by the NYC DOE in your current title?"
            },
            ...schoolYearsData,
            {
                type: "Checkbox",
                id: "appointed-after-school-year",
                content:[
                    {
                        label: "I was appointed <em>after</em> the school year began",
                        value: "checked",
                    }
                ]
            },
            {   
                type: 'Button', 
                precedence: "checkbox", 
                content: [
                    {
                        label: "Continue",
                        linkId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                        hidden: true,
                        variableId: "appointed-date"
                    },
                    {
                        label: "Continue",
                        linkId: "when-were-you-appointed-longevity",
                        hidden: true,
                        variableId: "appointed-after-school-year"
                    }
                ]
            },
        ]
    },
    {
        id: "when-were-you-appointed-longevity",
        jobTitle: 'school-psychologist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "When were you appointed?"
            },
            {
                type: "Dropdown",
                id: "appointed-month",
                content: [
                    {
                        label: "Month",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "January",
                        value: "01"
                    },
                    {
                        label: "February",
                        value: "02"
                    },
                    {
                        label: "March",
                        value: "03"
                    },
                    {
                        label: "April",
                        value: "04"
                    },
                    {
                        label: "May",
                        value: "05"
                    },
                    {
                        label: "June",
                        value: "06"
                    },
                    {
                        label: "July",
                        value: "07"
                    },
                    {
                        label: "August",
                        value: "08"
                    },
                    {
                        label: "September",
                        value: "09"
                    },
                    {
                        label: "October",
                        value: "10"
                    },
                    {
                        label: "November",
                        value: "11"
                    },
                    {
                        label: "December",
                        value: "12"
                    }
                ]
            },
            {
                type: "Dropdown",
                id: "appointed-day",
                content: [
                    {
                        label: "Day",
                        value: "",
                        disabled: true
                    },
                    {
                        label: "1",
                        value: "1"
                    },
                    {
                        label: "2",
                        value: "2"
                    },
                    {
                        label: "3",
                        value: "3"
                    },
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "5",
                        value: "5"
                    },
                    {
                        label: "6",
                        value: "6"
                    },
                    {
                        label: "7",
                        value: "7"
                    },
                    {
                        label: "8",
                        value: "8"
                    },
                    {
                        label: "9",
                        value: "9"
                    },
                    {
                        label: "10",
                        value: "10"
                    },
                    {
                        label: "11",
                        value: "11"
                    },
                    {
                        label: "12",
                        value: "12"
                    },
                    {
                        label: "13",
                        value: "13"
                    },
                    {
                        label: "14",
                        value: "14"
                    },
                    {
                        label: "15",
                        value: "15"
                    },
                    {
                        label: "16",
                        value: "16"
                    },
                    {
                        label: "17",
                        value: "17"
                    },
                    {
                        label: "18",
                        value: "18"
                    },
                    {
                        label: "19",
                        value: "19"
                    },
                    {
                        label: "20",
                        value: "20"
                    },
                    {
                        label: "21",
                        value: "21"
                    },
                    {
                        label: "22",
                        value: "22"
                    },
                    {
                        label: "23",
                        value: "23"
                    },
                    {
                        label: "24",
                        value: "24"
                    },
                    {
                        label: "25",
                        value: "25"
                    },
                    {
                        label: "26",
                        value: "26"
                    },
                    {
                        label: "27",
                        value: "27"
                    },
                    {
                        label: "28",
                        value: "28"
                    },
                    {
                        label: "29",
                        value: "29"
                    },
                    {
                        label: "30",
                        value: "30"
                    },
                    {
                        label: "31",
                        value: "31"
                    },
                ]
            },
            ...appointedYears,
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "have-you-ever-been-off-doe-payroll-for-more-than-30-days",
                        hidden: true
                    }
                ]
            },
        ]
    },
    {
        id: "no-longevity-increase",
        jobTitle: 'school-psychologist',
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "Keep going!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "At that time, the A/B in your salary step code will change to a V/W."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "See all of your longevity increases",
                        value: "pass",
                        linkId: "longevity-schedule"
                    }
                ]
            }
        ]
    },
    {
        id: "highest-longevity",
        jobTitle: 'school-psychologist',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "You are amazing!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "This increase has become part of your base salary and is pensionable."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "Go to final review",
                        linkId: "final-review",
                        value: "pass"
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-increase",
        jobTitle: 'school-psychologist',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "Congrats!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "This increase has become part of your annual salary and is pensionable."
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "See your next increases",
                        value: "pass",
                        linkId: "longevity-schedule"
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-schedule",
        jobTitle: 'school-psychologist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Here are your forecasted longevity dates."
            },
            {
                type: 'Modal',
                label: 'When will I see my pay increase?',
                title: "When will my longevity increase show up in my paycheck?",
                content: [
                    {
                        type: "Content",
                        content: "Longevity increases should be reflected in 1&ndash;2 pay periods following your eligibility date and will include any retroactive pay if applicable.",
                        textAlign: "center",
                    }
                ]
            },
            {
                type: "Longevity Schedule"
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "Continue",
                        linkId: "final-review",
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-increase",
        jobTitle: 'school-psychologist',
        background: [
            {
                image: require("../../src/imgs/confetti-green.gif"),
                size: "480px",
                repeat: "no-repeat",
                position: "top center"
            }
        ],
        stepNumber: 3,
        components: [
            {
                type: "Title",
                content: "Congrats!",
                underline: true
            },
            {
                type: "Longevity Date"
            },
            {
                type: "Content",
                content: "This increase has become part of your annual salary and is pensionable."
            },
            {   
                type: 'Button', 
                content: [
                    {
                        label: "See your next increases",
                        linkId: "longevity-schedule"
                    }
                ]
            }
        ]
    },
    {
        id: "longevity-schedule",
        jobTitle: 'school-psychologist',
        stepNumber: 3,
        components: [
            {
                type: "Sub Title",
                content: "Here are your forecasted longevity dates."
            },
            {
                type: 'Modal',
                label: 'When will I see my pay increase?',
                title: "When will my longevity increase show up in my paycheck?",
                content: [
                    {
                        type: "Content",
                        content: "Longevity increases should be reflected in 1&ndash;2 pay periods following your eligibility date and will include any retroactive pay if applicable.",
                        textAlign: "center",
                    }
                ]
            },
            {
                type: "Longevity Schedule"
            },
            {   
                type: 'Button', 
                id: "step-3-status",
                content: [
                    {
                        label: "Continue",
                        linkId: "final-review",
                        value: "pass"
                    }
                ]
            }
        ]
    },
    {
        id: "final-review",
        jobTitle: 'school-psychologist',
        background: [
            {
                color: "#17724D",
            }
        ],
        stepNumber: 4,
        components: [
            {
                type: "Title",
                content: "Final Review",
            },
            {
                type: "Sub Title",
                content: "We checked each aspect of your pay for errors."
            },
            {
                type: "Pay Code Stub",
                paycode: "",
            },
            {
                type: "Content Box",
                title: "College Credits",
                textAlign: "left",
                errorCheck: "step-1-status",
                content: [
                    {
                        content: 'Differentials',
                    },
                ],
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Differential Step Error"
                            },
                            {
                                type: "Content",
                                content: "Based on the information you provided, we believe you should have this differential:",
                                textAlign: "center",
                            },
                            {
                                type: "Pay Code",
                                codeType: "differential"
                            },
                            {
                                type: "Content",
                                content: "Most differential errors are a result of applying for the wrong differential or failing to apply for a differential altogether.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Report Error Online",
                                link: "https://hub.uft.org/uftselfservice/s/salary-inquiry-form",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Apply for a Differential",
                                link: "https://nycenet.edu/salapps",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Content Box",
                title: "Working Experience",
                textAlign: "left",
                errorCheck: "step-2-status",
                content: [
                    {
                        content: 'Salary Steps',
                    },
                ],
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Salary Step Error"
                            },
                            {
                                type: "Content",
                                content: "Based on the information you provided, we believe you should be on salary step:",
                                textAlign: "center",
                            },
                            {
                                type: "Pay Code",
                                codeType: "salary step"
                            },
                            {
                                type: "Content",
                                content: "Most salary step errors are caused by one of two things: forgetting to resubmit a salary step application after being off NYC DOE payroll for more than 30 days, or failing to submit information about qualifying work experience when initially hired.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Report Error Online",
                                link: "https://hub.uft.org/uftselfservice/s/salary-inquiry-form",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            },
                            {
                                type: "External Link",
                                label: "Resubmit a Salary Step Application",
                                link: "https://nycenet.edu/salapps",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Content Box",
                title: "Length of Employment",
                textAlign: "left",
                errorCheck: "step-3-status",
                content: [
                    {
                        content: 'Longevity',
                    },
                ],
                modal:[
                    {
                        label: 'Take action',
                        title: "Recommended Action",
                        content: [
                            {
                                type: "Alert",
                                level: "warning",
                                alert: "Longevity Issue"
                            },
                            {
                                type: "Content",
                                content: "Because you were off NYC DOE payroll for 30 or more days, we recommend that you call a UFT Salary Specialist to ensure your longevity schedule is correct.",
                                textAlign: "center",
                            },
                            {
                                type: "External Link",
                                label: "Call a UFT Salary Specialist",
                                link: "tel:212-331-6311",
                                isButtonStyle: true
                            }
                        ]
                    }
                ]
            },
            {
                type: "Salary Schedule Codes",
                title: "Your place on the NYC DOE salary schedule:",
                content: [
                    {
                        type: "Content",
                        content: "Be sure to review the salary schedule for the current year. The date is listed at the top."
                    },
                    {
                        type: "External Link",
                        label: "Open School Psychologist<br/>Salary Schedule",
                        link: "https://www.uft.org/your-rights/salary/doe-and-city-salary-schedules/school-psych-social-worker-salary-schedule"
                    }
                ]
            },
            {
                type: "Salary Schedule",
                title: "Forecasted salary step & longevity dates:",
                longevity: true
            }
        ]
    }
]